import React from 'react';
import RateUserDime from './RateUserDime';

const IMAGE_BASE = "https://p10-profile-image.s3.amazonaws.com";

const cardStyle = {
  width: "260px",
  background: "#fff",
  borderRadius: "16px",
  overflow: "hidden",
  boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
  paddingBottom: "16px",
  display: "flex",
  flexDirection: "column",
};

const imageWrapperStyle = {
  width: "100%",
  background: "#f3f3f3",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};

const imageStyle = {
  width: "100%",
  height: "auto",
  objectFit: "contain",
  display: "block",
};

const contentStyle = {
  padding: "10px 16px",
  textAlign: "center",
};

class UserDimeCard extends React.Component {
  render() {
    const { category, rating, image_key, dime_id, rating_count, setTest, userId } = this.props;
    const imageURL = `${IMAGE_BASE}/${image_key}`;
    const displayRating = rating ? Number(rating).toFixed(1) : "0.0";
    const totalRatings = rating_count || 0;
    
    return (
      <div style={cardStyle}>
        {/* IMAGE */}
        <div style={imageWrapperStyle}>
          <img src={imageURL} alt={category} style={imageStyle} />
        </div>
        
        {/* TEXT CONTENT */}
        <div style={contentStyle}>
          <h3 style={{ margin: "8px 0", fontSize: "1.2rem", fontWeight: "600" }}>
            {category}
          </h3>
          <p style={{ margin: "4px 0", fontSize: "0.95rem" }}>
            <strong>p10 Rating:</strong> {displayRating}
          </p>
          <p style={{ margin: "4px 0 12px 0", fontSize: "0.9rem", color: "#444" }}>
            <strong>Total Ratings:</strong> {totalRatings}
          </p>
          
          {/* RATE BUTTON - Pass userId prop */}
          <RateUserDime 
            setTest={setTest} 
            Name={category} 
            Id={dime_id} 
            ImageKey={image_key}
            userId={userId}
          />
        </div>
      </div>
    );
  }
}

export default UserDimeCard;